import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { CONTACT_ROUTES } from "@/src/contact/constants/contact-routes";
import { LEGAL_ROUTES } from "@/src/legal/constants/legal-routes";

interface LegalFooterProps {
	communityName?: string;
}

export function LegalFooter({ communityName }: LegalFooterProps = {}) {
	const { t } = useTranslation("legal");
	const year = new Date().getFullYear();

	return (
		<footer className="mt-12 border-t border-divider">
			<div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-4 px-6 py-10">
				<nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3 text-sm text-foreground/60">
					<Link to={LEGAL_ROUTES.PRIVACY} className="rounded px-2 py-1 transition-colors hover:bg-foreground/5 hover:text-foreground">
						{t("footer_privacy")}
					</Link>
					<span aria-hidden className="text-foreground/20">
						·
					</span>
					<Link to={LEGAL_ROUTES.TERMS_OF_USE} className="rounded px-2 py-1 transition-colors hover:bg-foreground/5 hover:text-foreground">
						{t("footer_terms_of_use")}
					</Link>
					<span aria-hidden className="text-foreground/20">
						·
					</span>
					<Link to={CONTACT_ROUTES.CONTACT} className="rounded px-2 py-1 transition-colors hover:bg-foreground/5 hover:text-foreground">
						{t("footer_contact")}
					</Link>
				</nav>
				<div className="flex w-full flex-wrap items-center justify-between gap-4">
					<p className="text-xs text-foreground/40">{communityName ? `© ${year} ${communityName}` : `© ${year}`}</p>
					<a
						href="https://www.upsquad.us"
						target="_blank"
						rel="noopener noreferrer"
						className="text-xs text-foreground/40 transition-colors hover:text-foreground/70"
					>
						{t("footer_powered_by")}
					</a>
				</div>
			</div>
		</footer>
	);
}
